// import { Layout } from "components/Layout/Layout";
import { useNav } from "../hooks/useNav";
import { UpdateEmailPage } from "./UpdateEmailPage";

// TODO: refactor the code to have the layout here and not be nested
export const UpdateEmail = () => {
  const { state: locationState } = useNav();
  if (!locationState) {
    return null;
  }
  const { account, fullPersonalDetails } = locationState;

  return (
    <UpdateEmailPage
      account={account}
      fullPersonalDetails={fullPersonalDetails}
    />
  );
};
